import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Input, Label } from "@/Components/ui";
import CommonDialog from "@/Components/Common/CommonDialog";
import { dialogService } from "@/utils/dialogService";

const DeleteOrRefundModal = ({ show, onDeleteClick, onCloseClick, onRefundClick, itemPrice, packageRefundAmount, totalRefundAmount }) => {
  const initialPackageRefundAmount = packageRefundAmount ?? itemPrice ?? 0;
  const fixedOptionRefundAmount = Math.max((totalRefundAmount ?? initialPackageRefundAmount) - initialPackageRefundAmount, 0);
  const [cancelAmtount, setCancelAmount] = useState(initialPackageRefundAmount);

  useEffect(() => {
    setCancelAmount(initialPackageRefundAmount);
  }, [initialPackageRefundAmount]);

  const finalRefundAmount = Number(cancelAmtount || 0) + fixedOptionRefundAmount;

  return (
    <CommonDialog
      isOpen={show}
      onClose={onCloseClick}
      title="예약 삭제"
      description="정말로 예약 건을 취소/환불 하시겠습니까?"
      tone="destructive"
      actions={[
        {
          label: "닫기",
          color: "light",
          closeOnClick: false,
          onClick: onCloseClick,
        },
        {
          label: "예약내역 삭제",
          color: "dark",
          closeOnClick: false,
          onClick: async () => {
            const confirmed = await dialogService.confirm({
              description: "예약내역 삭제(데이터만 삭제)하는 경우 PG사(토스)에서 직접 환불 처리해주셔야 합니다.",
              confirmLabel: "삭제 진행",
              cancelLabel: "취소",
              destructive: true,
            });
            if (!confirmed) return;
            onDeleteClick(cancelAmtount);
          },
        },
        {
          label: "환불처리",
          color: "danger",
          closeOnClick: false,
          onClick: async () => {
            const confirmed = await dialogService.confirm({
              title: "*** 주의 ***",
              description: "환불금액을 확인하셨습니까?\n실제 환불이 진행되며, 연결된 미사용 옵션도 함께 환불됩니다. 이후 환불 절차 취소가 불가능합니다.",
              confirmLabel: "환불 진행",
              cancelLabel: "취소",
              destructive: true,
            });
            if (!confirmed) return;
            onRefundClick(Number(cancelAmtount));
          },
        },
      ]}
    >
      <div className="space-y-3 px-2 text-start">
        <div>
          <Label htmlFor="cancelAmount-input" className="form-label">
            패키지 환불금액
          </Label>
          <Input
            id="cancelAmount-input"
            type="number"
            value={cancelAmtount}
            min="0"
            onChange={(e) => setCancelAmount(Number(e.target.value))}
          />
        </div>
        <div>
          <Label htmlFor="optionRefundAmount-input" className="form-label">
            연결 옵션 환불 예정금액
          </Label>
          <Input
            id="optionRefundAmount-input"
            type="number"
            value={fixedOptionRefundAmount}
            disabled
            readOnly
          />
        </div>
        <div>
          <Label htmlFor="finalRefundAmount-input" className="form-label">
            최종 환불 예상금액
          </Label>
          <Input
            id="finalRefundAmount-input"
            type="number"
            value={finalRefundAmount}
            disabled
            readOnly
          />
        </div>
        <p className="text-muted mb-0">
          옵션 상품 환불금액은 자동 계산되며 이 모달에서는 수정할 수 없습니다.
        </p>
        <p className="text-muted mb-0">
          예약내역 삭제(데이터만 삭제)하는 경우 PG사(토스)에서 직접 환불 처리해주셔야 합니다.
        </p>
      </div>
    </CommonDialog>
  );
};

DeleteOrRefundModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  onRefundClick: PropTypes.func,
  itemPrice: PropTypes.number,
  packageRefundAmount: PropTypes.number,
  totalRefundAmount: PropTypes.number,
};

export default DeleteOrRefundModal;
